let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("19Dzb")).then(() => parcelRequire('i57eq'));